import { useState, useCallback, useEffect } from 'react';
import MessengerApiService from '../services/MessengerApiService';

const useMessengerAccount = (agentId) => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(async () => {
    if (!agentId) return;
    setLoading(true);
    setError(null);
    try {
      const resp = await MessengerApiService.getStatus(agentId);
      setAccount(resp.data?.connected ? resp.data : null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  const oauthStart = useCallback(async () => {
    const resp = await MessengerApiService.oauthStart(agentId);
    return resp.data;
  }, [agentId]);

  const togglePaused = useCallback(
    async (paused) => {
      const resp = await MessengerApiService.update(agentId, {
        bot_paused: paused,
      });
      setAccount(resp.data);
      return resp.data;
    },
    [agentId],
  );

  const refreshProfile = useCallback(async () => {
    const resp = await MessengerApiService.update(agentId, {
      refresh_profile: true,
    });
    setAccount(resp.data);
    return resp.data;
  }, [agentId]);

  const disconnect = useCallback(async () => {
    await MessengerApiService.disconnect(agentId);
    setAccount(null);
  }, [agentId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return {
    account,
    loading,
    error,
    fetchStatus,
    oauthStart,
    togglePaused,
    refreshProfile,
    disconnect,
  };
};

export default useMessengerAccount;
